import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MarketButton } from '@market/react';
import Checkmark from '@square-icons/react/24/UI/check';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import InfoBubble from 'components/common/info_bubble';
import ProductClient from 'clients/product';
import { EMAIL_REGEX } from 'constants/patterns';

const NotifyMe = (props) => {
  const { slug, title } = props;

  const theme = useTheme();
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm();

  const onSubmit = async ({ email }) => {
    const pc = new ProductClient(slug);
    await pc.createLead(email).catch(() => {
      setError('email', {
        type: 'manual',
        message: t('error.api.generic'),
      });
    });
  };

  if (isSubmitSuccessful && !errors.email) {
    return (
      <InfoBubble icon={<Checkmark fill={theme.color.blue} />}>
        <p className="medium-30">{t('productPage.notifyMe.confirmation')}</p>
      </InfoBubble>
    );
  }

  return (
    <>
      <Box component="h3" sx={{ mb: 1 }}>
        {title || t('productPage.notifyMe.title')}
      </Box>
      <form id="notify-me-form" onSubmit={handleSubmit(onSubmit)}>
        <ControlledInputText
          name="email"
          control={control}
          defaultValue=""
          rules={{
            required: t('error.validation.invalidEmail'),
            pattern: {
              value: new RegExp(EMAIL_REGEX, 'i'),
              message: t('error.validation.invalidEmail'),
            },
          }}
          label={t('productPage.notifyMe.label')}
          placeholder={t('productPage.notifyMe.placeholder')}
        />
        <i
          className="paragraph-20"
          style={{
            display: 'block',
            color: theme.color.gray['55'],
            margin: theme.spacing(1, 0, 2, 0),
          }}
        >
          {t('productPage.notifyMe.disclaimer')}
        </i>
        <MarketButton
          {...(isSubmitting && { disabled: true })}
          id="notify-me-btn"
          rank="primary"
          type="submit"
          style={{ width: '100%' }}
        >
          {t('productPage.notifyMe.notifyButton')}
        </MarketButton>
      </form>
    </>
  );
};

export default NotifyMe;
